module.exports = __webpack_public_path__ + "static/media/unpin.e1a6aca3.svg";